import { useState } from "react";
import dayjs from "dayjs";

import { getLoadId } from "@/utils/load";
import { formatTimestamp } from "@/utils/date";
import { LoadboardTime, MyOfferText, LoadboardCancelModal, LoadViewDetailsModal } from "@/components/dataPages/loadboard";
import { cn } from "@/utils/css";
import { useCounterOffer } from "@/hooks/useCounterOffer";
import { TranslatedText } from "@/components/common/text";

export const MyOfferCard = ({ offer, index, onInteract }) => {
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const { acceptCounter, isLoading } = useCounterOffer();
    const isCountered = offer.status === "COUNTERED";
    const load = offer.loadBoardItem;
    const loadId = getLoadId(load.uniqueId);
    const timestamp = formatTimestamp(offer.updatedAt);

    const handleClick = () => {
        if (onInteract) {
            onInteract();
        }
    };
    // const hasCancel = offer.status === "PENDING" || (offer.status === "CONFIRMED" && offer.type === "quote");
    const hasCancel = false;

    return (
        <>
            {index ? <div className="h-[1px] self-center w-[calc(100%-24px)] bg-cm-p-outline" /> : null}
            <div className={cn("flex flex-col p-3 hover:bg-cm-p-surface-hover gap-2 cursor-pointer")} onClick={handleClick}>
                <div className="flex flex-row items-start justify-between">
                    <div className="flex flex-row items-center h-[41px]">
                        <div>
                            <div className="w-[154px] font-medium text-cm-p-text-primary text-sm/[22px]">
                                {load.itineraryStops[0]?.stopCity
                                    ? `${load.itineraryStops[0]?.stopCity}, ${load.itineraryStops[0]?.stopState}`
                                    : "-"}
                            </div>
                            <div className="text-cm-p-text-secondary text-xs/[19px] flex flex-row gap-1">
                                <div>{dayjs(load.pickupDate).format("MMM DD")},</div>
                                <LoadboardTime stop={load.itineraryStops[0]} />
                            </div>
                        </div>
                        <div>
                            <div className="w-[154px] font-medium text-cm-p-text-primary text-sm/[22px]">
                                {load.itineraryStops[load.itineraryStops.length - 1]?.stopCity
                                    ? `${load.itineraryStops[load.itineraryStops.length - 1]?.stopCity}, ${load.itineraryStops[load.itineraryStops.length - 1]?.stopState}`
                                    : "-"}
                            </div>
                            <div className="text-cm-p-text-secondary text-xs/[19px] flex flex-row gap-1">
                                {dayjs(load.deliveryDate).format("MMM DD")},
                                <LoadboardTime stop={load.itineraryStops[load.itineraryStops.length - 1]} />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        <div className="text-cm-p-text-primary font-medium text-sm/[22px]">{loadId}</div>
                        {timestamp ? (
                            <>
                                <div className="size-[2px] rounded-full bg-cm-p-text-secondary" />
                                <div className="text-cm-p-text-secondary text-sm/[22px]">{timestamp}</div>
                            </>
                        ) : null}
                    </div>
                </div>
                <div className="flex flex-row justify-between items-center">
                    <MyOfferText offer={offer} />
                    <div className="flex flex-row items-center gap-5">
                        {isCountered ? (
                            <button
                                type="button"
                                disabled={isLoading}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    acceptCounter(offer);
                                }}
                                className="text-cm-p-on-container-green font-medium text-sm/[22px] disabled:opacity-30"
                            >
                                <TranslatedText>Accept bid</TranslatedText>
                            </button>
                        ) : null}
                        {hasCancel ? (
                            <LoadboardCancelModal
                                offer={offer}
                                open={openCancelModal}
                                onOpenChange={setOpenCancelModal}
                                isDisabled={false}
                                reasonType="myOffers"
                            />
                        ) : null}
                        <LoadViewDetailsModal offer={offer} open={openDetailsModal} onOpenChange={setOpenDetailsModal} />
                    </div>
                </div>
            </div>
        </>
    );
};
